const locale = {
	TAB_ITEMS_PRICINGS: 'Orders pricings',
	TAB_ITEMS_MERCHPOINTS: 'Merch Points pricings',

	ITEMS_ERP_ID: 'ERP ID: {id}',

	// #region Items fields
	DETAILS_ITEMS_FIELD_TITLE: 'Title',
	DETAILS_ITEMS_FIELD_ERP_ID: 'ERP ID',
	DETAILS_ITEMS_FIELD_TYPE: 'Item Type',
	DETAILS_ITEMS_FIELD_UNITOFMEASURE: 'Unit of measure',
	DETAILS_ITEMS_FIELD_SERIES: 'Series',
	DETAILS_ITEMS_FIELD_MEASURE: 'Item Measure',
	DETAILS_ITEMS_FIELD_ORDSMINQTY: 'Minimum quantity (Order)',
	DETAILS_ITEMS_FIELD_ORDSMULTIPLE: 'Multiple (Order)',
	DETAILS_ITEMS_FIELD_WARNING: 'Warning',
	DETAILS_ITEMS_FIELD_BLOCKED: 'Blocked',
	DETAILS_ITEMS_FIELD_TAGS: 'Tags',
	// #endregion

	// #region Items Pricings
	DETAILS_ITEMS_PRICINGS_BUTTON_ADD_PRICING: 'Add pricing',

	DIALOG_ITEMS_PRICINGS_DIALOG_ADD_TITLE: 'Add pricing row',
	DIALOG_ITEMS_PRICINGS_DIALOG_EDIT_TITLE: 'Edit pricing row',

	DETAILS_ITEMS_PRICINGS_FIELD_DATE_FROM: 'Start date',
	DETAILS_ITEMS_PRICINGS_FIELD_DATE_TO: 'End date',
	DETAILS_ITEMS_PRICINGS_FIELD_PRICING_GROUP: 'Pricing group',
	DETAILS_ITEMS_PRICINGS_FIELD_COMPANY: 'Company',
	DETAILS_ITEMS_PRICINGS_FIELD_ORDSMINQTY: 'Minimum quantity (Order)',
	DETAILS_ITEMS_PRICINGS_FIELD_BASE_PRICE: 'Base price',
	DETAILS_ITEMS_PRICINGS_FIELD_DISCOUNTABLE: 'Discountable',
	// #endregion

	// #region Items Merch Points
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE: 'Type',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE_EARN: 'Earn',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE_PRICE: 'Price',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_FROM: 'Start date',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_TO: 'End date',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_PRICING_GROUP: 'Pricing group',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_ORDSMULTIPLE: 'Multiple (Order)',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_POINTS: 'Points',

	ITEMS_MERCHPOINTS_ADD_DIALOG_TITLE: 'Add pricing row',
	ITEMS_MERCHPOINTS_EDIT_DIALOG_TITLE: 'Edit pricing row'
	// #endregion
};

export default locale;
